var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[(_vm.currOptions && _vm.chartData)?_c('highcharts',{ref:"highcharts",staticClass:"hc",attrs:{"constructor-type":_vm.currType,"options":_vm.currOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }